import { Flex, Icon, Spacing, Text } from '@billy/design-system'
import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../../utils'
import styles from '../defaultStyles'
import { SortDirection, TableColumn, TableRow } from '../types'
import * as Styled from './styles'

export type TableHeadProps<T> = {
  className?: string
  columns: TableColumn<T>[]
  columnsLayout: string
  onHover?: (arg: boolean) => void
  onSort?: (property: string) => void
  rowSpacing?: number
}

export const TableHead = <T extends TableRow>({
  className,
  columns,
  columnsLayout,
  onHover = () => null,
  onSort = () => null,
  rowSpacing,
}: TableHeadProps<T>) => {
  return (
    <thead
      className={cc([className, reactClass('infinite-table-head')])}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <Styled.TableRow columns={columnsLayout} rowSpacing={rowSpacing}>
        {columns.map(({ field, isHeaderVisible = true, text = '', type, sortDirection, sortProperty }, index) => (
          <Flex as="th" justifyContent={styles[type].justifyContent} key={field.toString()} gap={Spacing.S6}>
            <Styled.TableHeaderTextWrapper sortProperty={sortProperty}>
              <Text key={index} onClick={() => sortProperty && onSort(sortProperty)} weight="bold">
                {isHeaderVisible && text}
              </Text>
            </Styled.TableHeaderTextWrapper>
            {sortDirection &&
              sortDirection !== SortDirection.None &&
              (sortDirection === SortDirection.Asc ? (
                <Icon icon="chevronDown" size="lg" />
              ) : (
                <Icon icon="chevronUp" size="lg" />
              ))}
          </Flex>
        ))}
      </Styled.TableRow>
    </thead>
  )
}
